module.exports = __webpack_public_path__ + "static/media/day-and-night.974eb0a5.svg";